"use client";

/** 질문·버그 게시판용 이름. 구현은 두 게시판 공용 `CommunityBoardShell` (JCG-3029). */
export { default } from "@/components/community/CommunityBoardShell";
